// models/metrics/metasearchMetrics/bing-hotel-ads/bingHotelAdsMetrics.js

// conversion
import MetricBookingcountBing from "models/metrics/metasearchMetrics/bing-hotel-ads/conversion/MetricBookingcount";
import MetricConversionBing from "models/metrics/metasearchMetrics/bing-hotel-ads/conversion/MetricConversion";
import MetricRevenuePerclickBing from "models/metrics/metasearchMetrics/bing-hotel-ads/conversion/MetricRevenuePerclick";

// performance
import MetricClicksBing from "models/metrics/metasearchMetrics/bing-hotel-ads/performance/MetricClicks";
import MetricCpcBing from "models/metrics/metasearchMetrics/bing-hotel-ads/performance/MetricCpc";
import MetricCsrBing from "models/metrics/metasearchMetrics/bing-hotel-ads/performance/MetricCsr";
import MetricCtrBing from "models/metrics/metasearchMetrics/bing-hotel-ads/performance/MetricCtr";
import MetricGeneratedBing from "models/metrics/metasearchMetrics/bing-hotel-ads/performance/MetricGenerated";
import MetricImprBing from "models/metrics/metasearchMetrics/bing-hotel-ads/performance/MetricImpr";
import MetricRoiBing from "models/metrics/metasearchMetrics/bing-hotel-ads/performance/MetricRoi";
import MetricSpentBing from "models/metrics/metasearchMetrics/bing-hotel-ads/performance/MetricSpent";

// visibility
import MetricEligImprBing from "models/metrics/metasearchMetrics/bing-hotel-ads/visibility/MetricEligImpr";
import MetricImprShareBing from "models/metrics/metasearchMetrics/bing-hotel-ads/visibility/MetricImprShareFromEligImpr";
import MetricMissedImprBing from "models/metrics/metasearchMetrics/bing-hotel-ads/visibility/MetricMissedImpr";
import MetricMissedImprBidBing from "models/metrics/metasearchMetrics/bing-hotel-ads/visibility/MetricMissedImprBid";
import MetricMissedImprNotaxBing from "models/metrics/metasearchMetrics/bing-hotel-ads/visibility/MetricMissedImprNotax";
import MetricMissedImprOtherBing from "models/metrics/metasearchMetrics/bing-hotel-ads/visibility/MetricMissedImprOther";

const bingHotelAdsMetrics = [
    // conversion
    new MetricBookingcountBing(),
    new MetricConversionBing(),
    new MetricRevenuePerclickBing(),
    // performance
    new MetricClicksBing(),
    new MetricCpcBing(),
    new MetricCsrBing(),
    new MetricCtrBing(),
    new MetricGeneratedBing(),
    new MetricImprBing(),
    new MetricRoiBing(),
    new MetricSpentBing(),
    // visibility
    new MetricEligImprBing(),
    new MetricImprShareBing(),
    new MetricMissedImprBing(),
    new MetricMissedImprBidBing(),
    new MetricMissedImprNotaxBing(),
    new MetricMissedImprOtherBing(),
];

export function findMetricById(metricId) {
    return bingHotelAdsMetrics.find((metricClass) => metricClass.field === metricId);
}

export default bingHotelAdsMetrics;
